import { Flash } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import classes from './styles.module.scss'

type VolatilityProps = {
  rating: number
  max: number
  activeCurrency: string
  isLoggedIn?: boolean
}
function VolatilityIndicator(props: VolatilityProps) {
  return (
    <div className={classes.root}>
      {Array(props.max)
        .fill(0)
        .map((i, index) => {
          const active = props.rating > index

          return (
            <Flash
              className={cx(
                classes.ico,
                active && props.activeCurrency === 'SC' && props.isLoggedIn && classes.activeSweep,
                active && props.activeCurrency === 'GC' && props.isLoggedIn && classes.activeGoldCoins,
                active && !props.isLoggedIn && classes.activeDefault,
              )}
              key={index}
            />
          )
        })}
    </div>
  )
}

export default VolatilityIndicator
